/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TwoFactorAuthPayload
 */
export interface TwoFactorAuthPayload {
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthPayload
     */
    uri: string;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorAuthPayload
     */
    code: string;
}

/**
 * Check if a given object implements the TwoFactorAuthPayload interface.
 */
export function instanceOfTwoFactorAuthPayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uri" in value;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function TwoFactorAuthPayloadFromJSON(json: any): TwoFactorAuthPayload {
    return TwoFactorAuthPayloadFromJSONTyped(json, false);
}

export function TwoFactorAuthPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): TwoFactorAuthPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uri': json['uri'],
        'code': json['code'],
    };
}

export function TwoFactorAuthPayloadToJSON(value?: TwoFactorAuthPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uri': value.uri,
        'code': value.code,
    };
}

